var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blurCapFeed"},_vm._l((2),function(index){return _c('BlurCapImageSkeleton',{key:index,staticClass:"blurCapItem",attrs:{"orientation":"portrait"}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }